import { Text, Tooltip } from '@lbcamden/lib-react';
import { FunctionComponent, PropsWithChildren } from 'react';

import { visitOutcomeDisplayValues } from '~/client/config/display-values/visits';
import { OfficerActivityResult } from '~/common/types/activityReport';
import { FailedVisitOutcome } from '~/common/types/visits';

type Props = PropsWithChildren<{
  failedVisitCount: number;
  failedVisitCountBreakdown: OfficerActivityResult['failedVisitCountBreakdown'];
}>;

export const FailedVisitsTooltip: FunctionComponent<Props> = ({
  failedVisitCount,
  failedVisitCountBreakdown,
}) =>
  failedVisitCount > 0 ? (
    <Tooltip
      contentContainerProps={{ css: { maxWidth: 'unset' } }}
      content={Object.entries(failedVisitCountBreakdown).map(([key, count]) => (
        <Text key={key}>
          {visitOutcomeDisplayValues[key as FailedVisitOutcome]}: {count}
        </Text>
      ))}
    >
      <Text css={{ maxWidth: 'fit-content', cursor: 'default' }} $color="primary" $weight={500}>
        {failedVisitCount}
      </Text>
    </Tooltip>
  ) : (
    failedVisitCount
  );
